import * as tokens from "./styles/styles-build/achieve/js/tokens.js";
import { createAscendTheme } from "./createAscendTheme.js";
const AchieveTheme = createAscendTheme({
  tokens,
  name: "achieve"
});
export {
  AchieveTheme
};
//# sourceMappingURL=AchieveTheme.js.map
